import React from 'react';
import {TouchableOpacity, View} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';
import FastImage from '../../Utils/FastImage';
///////////////////////////
///////////// components
import {
  BodyText,
  CloseIconButton,
  ContinueButton,
} from 'src/Modules/CommonView';

import {navigationRef} from 'src/Nav/navigationHelpers';
import {useImageSource, useLocation} from '../../Hooks/gameHooks';
import useParams from '../../Hooks/useParams';

const NavigationChallengeScoreModal = () => {
  const {width, height} = useWindowDimensionsSafe();

  const {onClose} = useParams();
  const {name, groupPointsEarned} = useLocation();
  const imageSource = useImageSource();

  return (
    <SafeAreaView style={{flex: 1, justifyContent: 'flex-end'}}>
      <TouchableOpacity
        style={{flex: 1}}
        onPress={() => {
          navigationRef.goBack(null);
          onClose && onClose();
        }}
      />
      <View
        style={{
          width,
          backgroundColor: global?.color?.white,
          borderRadius: 10,
          paddingVertical: 5,
          position: 'relative',
        }}>
        <View style={{alignItems: 'center'}}>
          <FastImage
            style={{
              width: width - 20,
              height: height <= 760 ? 210 : 240,
            }}
            source={imageSource}
            resizeMode={FastImage?.resizeMode?.contain}
          />
        </View>

        <View style={{marginTop: 10, marginBottom: 20}}>
          <BodyText
            text={'Congratulations'}
            textStyle={{
              textAlign: 'center',
              fontWeight: '700',
              fontSize: 18,
              lineHeight: 20,
            }}
          />
          <BodyText
            text={'You & Your Team Earned'}
            textStyle={{
              textAlign: 'center',
              fontWeight: '700',
            }}
          />

          <BodyText
            text={`${groupPointsEarned || '...'} pts`}
            textStyle={{
              textAlign: 'center',
              fontWeight: '700',
              fontSize: 24,
              lineHeight: 26,
              color: global?.color?.orange,
            }}
          />
          <BodyText
            text={`for checking in at`}
            textStyle={{
              textAlign: 'center',
            }}
          />
          <BodyText
            text={name}
            textStyle={{
              textAlign: 'center',
              fontWeight: '700',
              fontSize: 18,
              lineHeight: 20,
            }}
          />
        </View>
        <View style={{height: 55, paddingBottom: 10, paddingHorizontal: 5}}>
          <ContinueButton
            text={'View Challenges'}
            handlePress={() => {
              navigationRef.goBack(null);
              onClose && onClose();
            }}
            background={global?.color?.blue}
          />
        </View>

        <CloseIconButton
          handlePress={() => {
            navigationRef.goBack(null);
            onClose && onClose();
          }}
          side="right"
        />
      </View>
    </SafeAreaView>
  );
};

export default NavigationChallengeScoreModal;
